import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Col, Modal } from "react-bootstrap";
import Button from "../../components/shared/buttons/button";
import { CancelSvg } from "../../svgFiles/CancelSvg";
import useTranslator from "../../hooks/useTranslator";

const spinnerStyle = {
  width: "56px",
  height: "56px",
  border: "5px solid rgba(255, 255, 255, 0.28)",
  borderTop: "4px solid var(--primary-color)",
  borderRadius: "50%",
  animation: "logout-spin 0.8s linear infinite",
  margin: "0 auto",
};

const overlayStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 9999,
  background: "rgba(17, 24, 39, 0.58)",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
};

const panelStyle = {
  width: "min(520px, 100%)",
  background: "linear-gradient(180deg, #ffffff 0%, #fff7f1 100%)",
  borderRadius: "20px",
  padding: "40px 32px",
  boxShadow: "0 24px 80px rgba(15, 23, 42, 0.22)",
  textAlign: "center",
  border: "1px solid rgba(224, 123, 57, 0.16)",
};

const keyframes = `
  @keyframes logout-spin {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LogoutConfirmationModal = ({ show, setShow, onConfirmLogout }) => {
  const { _t } = useTranslator();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleClose = () => {
    if (isLoggingOut) return;
    setShow(false);
  };

  const handleLogout = () => {
    setShow(false);
    setIsLoggingOut(true);
    onConfirmLogout();
  };

  if (isLoggingOut) {
    return createPortal(
      <>
        <style>{keyframes}</style>
        <div style={overlayStyle}>
          <div style={panelStyle}>
            <div style={spinnerStyle} />
            <p
              style={{
                marginTop: "24px",
                marginBottom: "8px",
                fontSize: "28px",
                fontWeight: "700",
                color: "var(--heading-color)",
                letterSpacing: "-0.02em",
              }}
            >
              {_t("signing_out", "Signing out")}
            </p>
            <p
              style={{
                margin: 0,
                fontSize: "15px",
                lineHeight: "24px",
                color: "var(--label-color)",
              }}
            >
              {_t("logging_out_msg", "Please wait while we securely sign you out.")}
            </p>
          </div>
        </div>
      </>,
      document.body
    );
  }

  return (
    <>
      <style>{keyframes}</style>
      <Modal show={show} onHide={handleClose} centered size="md">
        <Modal.Header className="border-bottom-0 d-flex justify-content-between align-items-center">
          <h3 className="m-0">{_t("confirm_logout", "Confirm Logout")}</h3>
          <Button onClick={handleClose} icon={CancelSvg} size="small" />
        </Modal.Header>

        <Modal.Body>
          <Col lg={12}>
            <p style={{ fontSize: "16px", color: "#333" }}>
              {_t("logout_confirmation_msg", "Are you sure you want to logout?")}
            </p>
          </Col>
        </Modal.Body>

        <Modal.Footer className="border-top-0 pt-0">
          <Button label={_t("log_out", "Logout")} onClick={handleLogout} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LogoutConfirmationModal;
